import React from "react";
import "./Dropdown.scss";
import { FormikProps } from "formik";
import { Input } from "reactstrap";

interface DropdownProps {
  label: string;
  options: any[];
  name: string;
  value: string;
  touched?: boolean;
  error?: string;
  formik: FormikProps<any>;
  onChange?: (value: string) => void;
  placeholder: any;
}

const Dropdown = ({
  label,
  options,
  name,
  value,
  touched,
  error,
  formik,
  onChange,
  placeholder,
}: DropdownProps) => {
  const handleChange = (event: any) => {
    const selectedValue = event.target.value;
    if (onChange) {
      onChange(selectedValue);
    } else {
      formik.setFieldValue(name, selectedValue);
      if (name == "suppliers") {
        formik.setFieldValue("salesRepLead", "");
      }
    }
  };
  return (
    <div className="dropdown-custom">
      {label && <label className="dropdown-label">{label}</label>}
      <div>
        <div className="custom-select-wrapper">
          <Input
            name={name}
            type="select"
            value={value}
            onChange={handleChange}
            onBlur={formik.handleBlur}
            className="custom-select-input"
          >
            <option value="">{placeholder}</option>

            {options?.map((opt: any) => (
              <option key={opt.value || opt} value={opt.value || opt}>
                {opt.name || opt}
              </option>
            ))}
          </Input>
        </div>

        {touched && error && <div className="error-message">{error}</div>}
      </div>
    </div>
  );
};

export default Dropdown;
